var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.profileImageUrl)?[_c('img',{staticClass:"u-user-avatar-initial",class:_vm.sizeClassName,attrs:{"src":_vm.profileImageUrl}})]:[_c('i',{staticClass:"u-user-avatar-initial",class:_vm.sizeClassName,style:(_vm.initialIconStyle)},[_vm._v(_vm._s(_vm.lastNameInitial))])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }